import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchUserOrders({ payload: { page } }) {
  try {
    const result = yield call(AxiosCall, `/my-orders/?page=${page}`);
    yield put(actions.fetchUserOrdersSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchUserOrdersFailure(e.message || 'Failed to fetch orders'));
  }
}

function* fetchOrderDetail({ payload: { orderId } }) {
  try {
    const result = yield call(AxiosCall, `/my-orders/${orderId}/`);
    yield put(actions.fetchOrderDetailSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchOrderDetailFailure(e.message || 'Failed to fetch order'));
  }
}

function* trackOrder({ payload: { email, orderId } }) {
  try {
    const result = yield call(AxiosPost, `/shop/track_order/`, {
      email,
      order_id: orderId,
    });
    yield put(actions.trackOrderSuccess(result.data));
  } catch (e) {
    const errorMessage = e.response?.data?.error || e.message || 'Order not found';
    yield put(actions.trackOrderFailure(errorMessage));
  }
}

export default function* userOrdersSaga() {
  yield all([
    takeLatest(actions.FETCH_USER_ORDERS.REQUEST, fetchUserOrders),
    takeLatest(actions.FETCH_ORDER_DETAIL.REQUEST, fetchOrderDetail),
    takeLatest(actions.TRACK_ORDER.REQUEST, trackOrder),
  ]);
}
